import { render, staticRenderFns } from "./feedColumnOptions.vue?vue&type=template&id=779fe230&scoped=true&"
import script from "./feedColumnOptions.vue?vue&type=script&lang=js&"
export * from "./feedColumnOptions.vue?vue&type=script&lang=js&"
import style0 from "./feedColumnOptions.vue?vue&type=style&index=0&id=779fe230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779fe230",
  null
  
)

export default component.exports